(function () {
  const wrap = document.getElementById('variant-gallery-wrap');
  if (!wrap) return;

  const productUrl  = wrap.dataset.productUrl;
  const sectionId   = wrap.dataset.sectionId;
  const thumbSlider = document.getElementById('GalleryThumbnails-' + sectionId);
  const mainList    = document.getElementById('Slider-Gallery-' + sectionId);

  // Crea una lista separata per le nostre thumbnail — non tocchiamo mai Dawn
  const variantThumbList = document.createElement('ul');
  variantThumbList.className = 'thumbnail-list list-unstyled slider slider--mobile variant-thumb-list';
  variantThumbList.style.display = 'none';

  if (thumbSlider) {
    // Inseriamo la nostra lista dentro lo stesso slider-component di Dawn
    const innerUl = thumbSlider.querySelector('ul.thumbnail-list');
    if (innerUl) innerUl.after(variantThumbList);
  }

  function getMainImage() {
    if (!mainList) return null;
    return mainList.querySelector('.product__media-item.is-active img')
        || mainList.querySelector('.product__media-item img');
  }

  function buildVariantThumbs(images) {
    variantThumbList.innerHTML = '';

    images.forEach(function (img, i) {
      const li  = document.createElement('li');
      li.className = 'thumbnail-list__item slider__slide';

      const btn = document.createElement('button');
      btn.className   = 'thumbnail global-media-settings global-media-settings--no-shadow';
      btn.type        = 'button';
      btn.dataset.full = img.full;
      btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');

      const imgEl = document.createElement('img');
      imgEl.src    = img.thumb;
      imgEl.width  = 74;
      imgEl.height = 74;
      imgEl.style.cssText = 'object-fit:cover;width:100%;height:100%;aspect-ratio:1/1';
      imgEl.loading = 'lazy';

      btn.addEventListener('click', function () {
        const mainImg = getMainImage();
        if (mainImg) {
          mainImg.src    = img.full;
          mainImg.srcset = '';
        }
        variantThumbList.querySelectorAll('button').forEach(b => b.setAttribute('aria-current', 'false'));
        btn.setAttribute('aria-current', 'true');
      });

      btn.appendChild(imgEl);
      li.appendChild(btn);
      variantThumbList.appendChild(li);
    });
  }

  function showVariantThumbs(images) {
    buildVariantThumbs(images);
    // Nascondi lista Dawn, mostra la nostra
    if (thumbSlider) {
      const dawnUl = thumbSlider.querySelector('ul.thumbnail-list:not(.variant-thumb-list)');
      if (dawnUl) dawnUl.style.display = 'none';
      thumbSlider.style.display = '';
    }
    variantThumbList.style.display = '';
  }

  function showDawnThumbs() {
    // Ripristina lista Dawn, nascondi la nostra
    if (thumbSlider) {
      const dawnUl = thumbSlider.querySelector('ul.thumbnail-list:not(.variant-thumb-list)');
      if (dawnUl) dawnUl.style.display = '';
    }
    variantThumbList.style.display = 'none';
    variantThumbList.innerHTML = '';
  }

  function updateGallery(variantId) {
    const url = productUrl + '?variant=' + variantId + '&section_id=' + sectionId;

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc     = new DOMParser().parseFromString(html, 'text/html');
        const newWrap = doc.getElementById('variant-gallery-wrap');
        const imgs    = newWrap ? Array.from(newWrap.querySelectorAll('img')) : [];

        if (imgs.length > 0) {
          const images = imgs.map(img => ({
            full:  img.dataset.full,
            thumb: img.getAttribute('src')
          }));
          showVariantThumbs(images);
        } else {
          showDawnThumbs();
        }
      })
      .catch(err => console.error('Variant gallery error:', err));
  }

  document.addEventListener('change', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) updateGallery(variantInput.value);
  });

  const initVariant = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (initVariant) updateGallery(initVariant.value);

})();